import React from 'react';
import logo from 'static/images/gofreecredit-header-logo.svg';

const GFCLogo = () => <img src={logo} alt="" />;

export default GFCLogo;
